module.exports = __webpack_public_path__ + "img/WooCommerce.ee3f90f4.svg";